
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 43 39"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.348 3V0H43v3H9.348zM0 21v-3h42.994v3H0zm0 18v-3h42.994v3H0z"}})])
          )
        }
      }
    